import React from "react";
import { AutocompleteRenderOptionState, FilterOptionsState } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { ui } from "../../../../../../../../../interfaces/interfaces";
import { StringProcessor } from "@utils/stringProcessor";
import { CacheTypes } from "@utils/cache/interfaces";

export const handleJobSearchChange = (
  event: React.SyntheticEvent<Element, Event>,
  value: CacheTypes.JobTypeOptions | null,
  inputRef: any
) => {
  if (value?.jobTypeCode) {
    ui.ProblemComboJobSearch = value;
    inputRef.current.focus()
    // setJobValid, setCategoryValid, setTradeValid
  }
  else {
    ui.ProblemComboJobSearch = value;
  }
};

export const renderOption = (
  props: React.HTMLAttributes<HTMLLIElement>,
  option: CacheTypes.JobTypeOptions,
  state: AutocompleteRenderOptionState
) => {
  const matches = match(`${option.jobDescription} [${option.jobTypeCode}]`, state.inputValue);
  const parts = parse(`${option.jobDescription} [${option.jobTypeCode}]`, matches);
  return (
    <li {...props} key={option.jobTypeCode}>
      <div>
        {parts.map((part, index) => (
          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400, }}>
            {part.text}
          </span>))}
      </div>
    </li>
  );
};

export const jobSearchGetOptionLabel = (options: CacheTypes.JobTypeOptions) => `${options.jobDescription} [${options.jobTypeCode}]`;
export const jobSearchIsOptionEqualToValue = (option: CacheTypes.JobTypeOptions, value: CacheTypes.JobTypeOptions) =>
  option?.jobTypeCode === value?.jobTypeCode;

export const customFilter = (options: CacheTypes.JobTypeOptions[], state: FilterOptionsState<CacheTypes.JobTypeOptions>) => {
  return StringProcessor.wordsInWordFilter(options, state.inputValue);
};
